import * as React from 'react';
import { SearchFiltersTranslation } from '../constants';
import { FilterMenuOption, FilterMenuValues } from './types';
import styles from './filter-panel-menu.scss';

interface FilterPanelMenuProps {
  options?: FilterMenuOption;
  values?: FilterMenuValues;
  translation: SearchFiltersTranslation;
}

export const FilterPanelMenu = ({ options, values, translation }: FilterPanelMenuProps) => {
  const displayExclude = options?.excludeInclude && values?.exclude;
  const displayExcludeChildren = options?.excludeIncludeChildren && values?.excludeChildren;
  const displayExcludeParents = options?.excludeIncludeParents && values?.excludeParents;
  const shouldRenderFilterPanelMenu = (displayExclude || displayExcludeChildren || displayExcludeParents) && options;

  return <div className="clearfix">
    {shouldRenderFilterPanelMenu
      ?
      <div className="float-left">
        <ul className={styles.options}>
          {displayExclude && <li>
            <span>{translation.filter_menu_option_exclude}</span>
          </li>}
          {displayExcludeChildren && <li>
            <span>{translation.filter_menu_option_exclude_sub}</span>
          </li>}
          {displayExcludeParents && <li>
            <span>{translation.filter_menu_option_exclude_parent}</span>
          </li>}
        </ul>
      </div> : null}
  </div>;
};
